export default function validateStartingURL(startingURL: string): string[] {
  const startingURLTrimmed = startingURL.trim();

  const errors: string[] = [];
  if (startingURLTrimmed === "") {
    return ["Starting URL is required"];
  }

  if (!startingURLTrimmed.startsWith("https://")) {
    return ["Starting URL must use HTTPS as the protocol"];
  }

  try {
    const startingURLParsed = new URL(startingURLTrimmed);

    if (startingURLParsed.protocol !== "https:") {
      errors.push(
        `Starting URL must use HTTPS as the protocol, got: ${startingURLParsed.protocol
          .slice(0, -1)
          .toLocaleUpperCase()}`
      );
    }

    if (startingURLParsed.pathname !== "/") {
      errors.push(
        `Starting URL must not have a path, got: ${startingURLParsed.pathname}`
      );
    }

    if (startingURLParsed.search !== "") {
      errors.push(
        `Starting URL must not have a query string, got: ${startingURLParsed.search}`
      );
    }
  } catch (_e) {
    errors.push("Starting URL is not a valid URL");
  }

  return errors;
}
